export default "__VITE_ASSET__BK20Uszt__"